import React, { Component } from 'react';
import { withRouter } from "react-router";
import bibleJson from "../utils/bible";

let bibleChapter = bibleJson[Math.floor(Math.random() * bibleJson.length)];
let bibleChapterNumber = Math.floor(Math.random() * bibleChapter.chapters.length);
let bibleResult = bibleChapter.chapters[bibleChapterNumber];
let bibleVerseNumber = Math.floor(Math.random() * bibleResult.length);
let bibleVerse = bibleResult[bibleVerseNumber];

class JournalPromptHome extends Component{
  constructor() {
    super()
    this.state = {
      bibleChapterNumber: bibleChapterNumber + 1,
      bibleChapter: bibleChapter.name,
      bibleVerseNumber: bibleVerseNumber + 1,
      bibleVerse: bibleVerse
    }
  }

  _getAnother = () => {
    let bibleChapter = bibleJson[Math.floor(Math.random() * bibleJson.length)];
    let bibleChapterNumber = Math.floor(Math.random() * bibleChapter.chapters.length);
    let bibleResult = bibleChapter.chapters[bibleChapterNumber];
    let bibleVerseNumber = Math.floor(Math.random() * bibleResult.length);
    let bibleVerse = bibleResult[bibleVerseNumber];
    
    this.setState({
      bibleChapterNumber: bibleChapterNumber + 1,
      bibleChapter: bibleChapter.name,
      bibleVerseNumber: bibleVerseNumber + 1,
      bibleVerse: bibleVerse
    })
  }

  render() {
    const { bibleChapter, bibleVerseNumber, bibleVerse, bibleChapterNumber } = this.state   
    
    return(
      <div className="Container Container--md Container--side-padding Container-vc">
        <div className="ui-box fade-up">
          <div className="journal-prompt">
            <h1>{bibleVerse}</h1>
            <p><code style={{ color: '#999' }}>{bibleChapter + " " + bibleChapterNumber + "-" + bibleVerseNumber}</code></p>
            <div className="write-prompt">
              <button 
                className="cta-btn btn-happy"
                id="journalPrompt_write"
                onClick={() => window.location = 'https://app.goodnightjournal.com/write?journalPrompt=' + bibleVerse + " " + bibleChapter + " " + bibleChapterNumber + "-" + bibleVerseNumber}>
                  Write about it
              </button>
              <button className="cta-btn btn-happy btn-secondary" id="journalPrompt_get_another" onClick={this._getAnother}>Get another</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(JournalPromptHome)